import React from 'react';

const AdminEmptyState = ({ icon: Icon, title, description }) => (
  <div className="text-center py-16 bg-white rounded-xl border border-gray-200/80 shadow-sm">
    <div className="w-14 h-14 bg-gray-50 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-gray-100">
      <Icon className="text-2xl text-gray-300" />
    </div>
    <p className="text-designer-dark font-semibold text-base">{title}</p>
    <p className="text-gray-400 text-sm mt-1 max-w-xs mx-auto">{description}</p>
  </div>
);

export default AdminEmptyState;
